<template>

  <div>

  <div v-if="!submit" v-bind:style="{color: survey.colors.text_color}">

    <div class="hit-form-group">
      <h5 class="hit-html-h5" v-bind:style="{color: survey.colors.text_color}">{{ $tc("message.idea", 2) }} / {{ $tc("message.suggestionForImprovement", 2) }}</h5>
    </div>

  <div class="hit-form-group">

      <textarea v-bind:style="{'background': survey.colors.background_color, 'color': survey.colors.text_color, 'border-color': survey.colors.accent_color}" class="hit-form-control" v-bind:placeholder="$t('message.personalData')+' ('+$t('message.notPublic')+')'"  v-model="r.hint"></textarea>

</div>

<personalData v-if="!survey.save" :survey="survey" :error="error" :settings="settings" :r="r" />

<hr class="hit-html-hr" v-bind:style="{'border-color': survey.colors.accent_color}">

<div class="hit-row">
  <div class="hit-col-md-6">
    <hit_privacy :callback="function(data){ change_privacy(data); }"/>
  </div>
  <div class="hit-col-md-6">
    <hit_terms :callback="function(data){ change_terms(data); }"/>
  </div>
</div>

<div class="hit-form-group">
  <button class="hit-btn hit-btn-primary hit-btn-block" v-bind:class="get_send_btn()" v-bind:style="{'border-color': survey.colors.accent_color, 'background': survey.colors.accent_color, 'color': survey.colors.accent_color2}" v-on:click="check_submit"><b>{{ $t("message.save", {name: $tc("message.feedback", 1)}) }}</b> <br><hit_stars :stars="get_avg()" v-bind:key="settings.update_key"/></button>
</div>

  </div>

  <div v-if="submit" class="hit-html-html" style="padding-top: 20px;" v-bind:style="{'color': survey.colors.accent_color}">

      <div class="hit-alert hit-alert-success"><div><b>{{ $t("message.thankYou") }}</b> {{ $t("message.validationLinkSendedTo", {name: r[settings.validation_method]  }) }}</div></div>

  </div>

  </div>

</template>

<script>

import md5 from 'js-md5'

import hit_privacy from '@core/components/assets/hit_privacy.vue'
import hit_terms from '@core/components/assets/hit_terms.vue'
import personalData from '@core/components/survey/personalData.vue'

export default{

  props: { survey: Object, save: Object },
  components: {
    hit_privacy,
    hit_terms,
    personalData
  },
  data: function () {
    return {
      submit: false,
      settings: {
        validation_method: 'email'
      },
      r: {
        hint: '',
        email: '',
        handy: '',
        validation: 'email',
        name: ''
      },

      error: {
        email: true,
        name: true,
        handy: true,
        privacy: true,
        terms: true
      }

    }
  },

  watch: {

    'r.email': function (val) {
      this.error.email = false

      if (!this.validateEmail(val)) {
        this.error.email = true
      }
    },
    'r.name': function (val) {
      this.error.name = false

      if (val.length < 3) {
        this.error.name = true
      }
    },
    'r.handy': function (val) {
      this.error.handy = false

      if (val.length < 8) {
        this.error.handy = true
      }
    }

  },

  methods: {

    get_send_btn: function () {
      if (!this.check_errors()) { return false }

      return {
        'hit-disabled': true
      }
    },

    change_privacy: function (data) {
      this.error.privacy = !data
    },

    change_terms: function (data) {
      this.error.terms = !data
    },

    get_toggle: function () {
      var txt = {}
      txt.email = '<hit_icon :id="\'envelope\'" />' + this.$t('message.email')
      txt.sms = '<hit_icon :id="\'iphone\'" /> ' + this.$t('message.mobileNumber')

      var r = {}

      r[txt.sms] = 'handy'
      r[txt.email] = 'email'

      return r
    },
    get_avg: function () {
      var sum = 0

      Object.values(this.save.stars).forEach(function (val) {
        sum += val
      })

      return (sum / Object.keys(this.save.stars).length)
    },

    validateEmail: function (email) {
      return /[^@]+@[^@]+\.[^@]+/.test(email)
    },

    check_errors: function () {
      var error = false

      var check_error = JSON.parse(JSON.stringify(this.error))

      if (this.r.validation == 'email') { delete check_error['handy'] } else { delete check_error['email'] }

      for (var i = 0; i < Object.keys(check_error).length; i++) {
        if (this.error[ Object.keys(check_error)[i] ] === true) { error = true }
      }

      return error
    },

    check_submit: function () {
      if (!this.check_errors()) { this.save_submit() }
    },

    save_submit: function () {
      var stars = []
      var comments = []
      var my_class = this

      Object.keys(this.save.stars).forEach(function (val) {
        var obj = {}
        obj[val] = my_class.save.stars[val]

        var obj2 = {}
        obj2[val] = my_class.save.comments[val]

        stars.push(obj)
        comments.push(obj2)
      })

      var send = {
        user: this.$store.getters.user.md5_id,
        board: this.survey.ID,
        stars: stars,
        description: comments,
        average: this.get_avg()

      }

      if (typeof this.survey.user === 'string') { send.user = this.survey.user }

      send = Object.assign(send, {adress: this.r})

      my_class.$hit_post({url: 'hitclick/votes/set/',
        data: send,
        callback: function (ret) {
          if (ret.data[0]) {
            my_class.submit = true
            my_class.send_validation_mail(ret.data[1], send)
            my_class.set_chat_msg(ret.data[1], send)
          }
        }})
    },

    set_chat_msg (form, data) {
      var send = {
        user: data.user,
        data: {
          chat_nr: md5(data.board + '') + '-' + md5(form.ID + ''),
          msg: this.$tc('message.feedback', 1) + ' #' + data.board + '-' + form.ID + ' ' + this.$t('message.successfullSendet'),
          user: 2,
          view: [2, 3]
        }
      }

      this.$store.dispatch('set_chat', send)
    },

    send_validation_mail (form, data) {

      var link = ''

      if (typeof this.$router === 'object') {
        link = this.$get_url().www_url + this.$router.resolve({ name: 'vote_confirm',
          params: {
            lang: this.$route.params.lang,
            userID: data.user,
            boardID: md5(data.board + ''),
            entryID: md5(form.ID + '')
          }
        }).href
      } else {
        link = this.$get_url().www_url + '/de/'+ data.user +'/' + md5(data.board + '') + '/' + md5(form.ID + '') + '/confirm.html'
      }

      link = '<a href="' + link + '" target="_blank">' + link + '</a>'

      var send = {}

      send.user = data.user
      send.data = {
        email: {
          title: this.$t('email.validationEmail.title'),
          text: this.$nl2br(this.$t('email.validationEmail.text', {link: link})),
          to: data.adress.email
        }
      }

      this.$hit_post({url: 'hitclick/votes/send_confirm', data: send, callback: function (ret) { }})
    }

  },
  mounted () {
    if (typeof this.survey.save === 'object') {
      this.r.email = this.survey.save.email
      this.r.name = this.survey.save.name
    }
  }

}

</script>
